<ol class="steps" aria-label="Etapas da investigação">
  @for (step of steps(); track step.key) {
    <li
      class="step step--{{ step.state }}"
      [attr.aria-current]="step.state === 'current' ? 'step' : null">
      <span class="step__icon" aria-hidden="true">
        @switch (step.state) {
          @case ('done') {
            <i class="pi pi-check"></i>
          }
          @case ('current') {
            <app-cog-loading-spinner [size]="14" />
          }
          @default {
            <span class="step__dot"></span>
          }
        }
      </span>
      <span class="step__body">
        <span class="step__label">
          {{ step.label }}
          <span class="sr-only">
            @switch (step.state) {
              @case ('done') {
                (feita)
              }
              @case ('current') {
                (em andamento)
              }
              @default {
                (a fazer)
              }
            }
          </span>
        </span>
        @if (step.detail) {
          <span class="step__detail">{{ step.detail }}</span>
        }
      </span>
    </li>
  }
</ol>

@if (activity() || elapsed()) {
  <p class="activity">
    @if (activity(); as text) {
      <span class="activity__text" [title]="text">{{ text }}</span>
    }
    @if (elapsed(); as label) {
      <span class="activity__elapsed">{{ label }}</span>
    }
  </p>
}
